


  import dep0 from "@ember-data/adapter/-embroider-implicit-modules.js";
  import dep1 from "@ember-data/graph/-embroider-implicit-modules.js";
  import dep2 from "@ember-data/json-api/-embroider-implicit-modules.js";
  import dep3 from "@ember-data/legacy-compat/-embroider-implicit-modules.js";
  import dep4 from "@ember-data/model/-embroider-implicit-modules.js";
  import dep5 from "@ember-data/request/-embroider-implicit-modules.js";
  import dep6 from "@ember-data/request-utils/-embroider-implicit-modules.js";
  import dep7 from "@ember-data/serializer/-embroider-implicit-modules.js";
  import dep8 from "@ember-data/store/-embroider-implicit-modules.js";
  import dep9 from "@ember-data/tracking/-embroider-implicit-modules.js";
  import dep10 from "@ember/test-helpers/-embroider-implicit-modules.js";
  import dep11 from "@glimmer/component/-embroider-implicit-modules.js";
  import dep12 from "@nullvoxpopuli/ember-composable-helpers/-embroider-implicit-modules.js";
  import dep13 from "@warp-drive/core-types/-embroider-implicit-modules.js";
  import dep14 from "ember-basic-dropdown/-embroider-implicit-modules.js";
  import dep15 from "ember-changeset/-embroider-implicit-modules.js";
  import dep16 from "ember-changeset-validations/-embroider-implicit-modules.js";
  import dep17 from "ember-cli-babel/-embroider-implicit-modules.js";
  import dep18 from "ember-cli-flash/-embroider-implicit-modules.js";
  import dep19 from "ember-concurrency/-embroider-implicit-modules.js";
  import dep20 from "ember-cookies/-embroider-implicit-modules.js";
  import dep21 from "ember-data/-embroider-implicit-modules.js";
  import dep22 from "ember-inflector/-embroider-implicit-modules.js";
  import dep23 from "ember-modifier/-embroider-implicit-modules.js";
  import dep24 from "ember-moment/-embroider-implicit-modules.js";
  import dep25 from "ember-page-title/-embroider-implicit-modules.js";
  import dep26 from "ember-pikaday/-embroider-implicit-modules.js";
  import dep27 from "ember-power-select/-embroider-implicit-modules.js";
  import dep28 from "ember-qunit/-embroider-implicit-modules.js";
  import dep29 from "ember-route-template/-embroider-implicit-modules.js";
  import dep30 from "ember-simple-auth/-embroider-implicit-modules.js";
  import dep31 from "ember-source/-embroider-implicit-modules.js";
  import dep32 from "ember-truth-helpers/-embroider-implicit-modules.js";
  import dep33 from "ember-validators/-embroider-implicit-modules.js";
  import dep34 from "liquid-fire/-embroider-implicit-modules.js";
  import dep35 from "tracked-built-ins/-embroider-implicit-modules.js";
  import dep36 from "@embroider/macros/-embroider-implicit-modules.js";
  import dep37 from "@ember/optional-features/-embroider-implicit-modules.js";
  import dep38 from "@ember/render-modifiers/-embroider-implicit-modules.js";
  import dep39 from "@glimmer/tracking/-embroider-implicit-modules.js";
  import dep40 from "ember-cached-decorator-polyfill/-embroider-implicit-modules.js";
  import dep41 from "ember-template-imports/-embroider-implicit-modules.js";
  import dep42 from "ember-auto-import/-embroider-implicit-modules.js";
  import dep43 from "ember-app-scheduler/-embroider-implicit-modules.js";
  import dep44 from "ember-cli-htmlbars/-embroider-implicit-modules.js";
  import dep45 from "ember-burger-menu/-embroider-implicit-modules.js";
  import dep46 from "ember-cli-deprecation-workflow/-embroider-implicit-modules.js";
  import dep47 from "ember-cli-inline-content/-embroider-implicit-modules.js";
  import dep48 from "ember-cli-sass/-embroider-implicit-modules.js";
  import dep49 from "ember-data-date-only-transform/-embroider-implicit-modules.js";
  import dep50 from "ember-event-helpers/-embroider-implicit-modules.js";
  import dep51 from "ember-leaflet/-embroider-implicit-modules.js";
  import dep52 from "ember-leaflet-marker-cluster/-embroider-implicit-modules.js";
  import dep53 from "ember-local-storage/-embroider-implicit-modules.js";
  import dep54 from "ember-responsive/-embroider-implicit-modules.js";
  import dep55 from "ember-router-scroll/-embroider-implicit-modules.js";
  import dep56 from "ember-svg-jar/-embroider-implicit-modules.js";
  import dep57 from "ember-table/-embroider-implicit-modules.js";
  import dep58 from "ember-tether/-embroider-implicit-modules.js";
  import dep59 from "ember-uuid/-embroider-implicit-modules.js";
  import dep60 from "perf-primitives/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
    dep7,
    dep8,
    dep9,
    dep10,
    dep11,
    dep12,
    dep13,
    dep14,
    dep15,
    dep16,
    dep17,
    dep18,
    dep19,
    dep20,
    dep21,
    dep22,
    dep23,
    dep24,
    dep25,
    dep26,
    dep27,
    dep28,
    dep29,
    dep30,
    dep31,
    dep32,
    dep33,
    dep34,
    dep35,
    dep36,
    dep37,
    dep38,
    dep39,
    dep40,
    dep41,
    dep42,
    dep43,
    dep44,
    dep45,
    dep46,
    dep47,
    dep48,
    dep49,
    dep50,
    dep51,
    dep52,
    dep53,
    dep54,
    dep55,
    dep56,
    dep57,
    dep58,
    dep59,
    dep60,
  {
  }
);
